module.exports = __webpack_public_path__ + "static/media/no-trips.2f5a6a15.svg";